export default __webpack_public_path__ + "static/media/app-icon-actguide.33369a9c.png";